export enum StockMovementType {
  // Stock Inflows (Adding to inventory)
  PURCHASE_ORDER = 100, // Goods purchased from a supplier
  STOCK_TRANSFER_IN = 101, // Stock transferred into the store from another location
  CUSTOMER_RETURN = 102, // Returned items from customers added back to inventory
  MANUAL_ADJUSTMENT_IN = 103, // Manual increase in stock (e.g., found stock)
  INVENTORY_COUNT_INCREASE = 104, // Adjustments after physical count indicates more stock
  ORDER_EDITION = 105, // Stock adjustments due to order edition

  // Stock Outflows (Removing from inventory)
  SALE = 200, // Goods sold to customers
  STOCK_TRANSFER_OUT = 201, // Stock transferred out to another location
  RETURN_TO_SUPPLIER = 202, // Returning defective or excess stock to supplier
  MANUAL_ADJUSTMENT_OUT = 203, // Manual decrease in stock (e.g., write-offs)
  INVENTORY_COUNT_DECREASE = 204, // Adjustments after physical count indicates less stock

  // Stock Reservations (Allocations)
  STOCK_RESERVED = 300, // Stock reserved for a customer (not yet sold)
  STOCK_RELEASED = 301, // Reserved stock released back to inventory

  // Stock Corrections
  DAMAGE_WRITE_OFF = 400, // Stock written off due to damage
  THEFT_LOSS = 401, // Stock loss due to theft or misplacement

  // Others
  STOCK_ADJUSTMENT = 500, // General stock adjustments
  PRODUCTION_USAGE = 501, // Stock used in production or assembly
  SAMPLE_DISTRIBUTION = 502, // Stock given out as samples
  PROMOTIONAL_USE = 503, // Stock used for promotions or marketing
}

export const USABLE_STOCK_MOVEMENT_TYPES = [
  StockMovementType.PURCHASE_ORDER,
  StockMovementType.SALE,
  StockMovementType.STOCK_ADJUSTMENT,
];

export const STOCK_MOVEMENT_TYPE_LABELS = {
  // Stock Inflows
  [StockMovementType.PURCHASE_ORDER]: {
    label: 'Compra de mercadería',
    icon: 'mdi-cart',
    direction: 1, // Inflow
  },
  [StockMovementType.STOCK_TRANSFER_IN]: {
    label: 'Transferencia de stock entrante',
    icon: 'mdi-truck-delivery',
    direction: 1, // Inflow
  },
  [StockMovementType.CUSTOMER_RETURN]: {
    label: 'Devolución de cliente',
    icon: 'mdi-undo',
    direction: 1, // Inflow
  },
  [StockMovementType.MANUAL_ADJUSTMENT_IN]: {
    label: 'Ajuste manual de ingreso',
    icon: 'mdi-plus-box',
    direction: 1, // Inflow
  },
  [StockMovementType.INVENTORY_COUNT_INCREASE]: {
    label: 'Aumento después de recuento de inventario',
    icon: 'mdi-database-plus',
    direction: 1, // Inflow
  },
  [StockMovementType.ORDER_EDITION]: {
    label: 'Reestablecimiento por edición de pedido',
    icon: 'mdi-restart',
    direction: 1, // Inflow
  },

  // Stock Outflows
  [StockMovementType.SALE]: {
    label: 'Venta',
    icon: 'mdi-sale',
    direction: -1, // Outflow
  },
  [StockMovementType.STOCK_TRANSFER_OUT]: {
    label: 'Transferencia de stock saliente',
    icon: 'mdi-truck-delivery',
    direction: -1, // Outflow
  },
  [StockMovementType.RETURN_TO_SUPPLIER]: {
    label: 'Devolución al proveedor',
    icon: 'mdi-undo-variant',
    direction: -1, // Outflow
  },
  [StockMovementType.MANUAL_ADJUSTMENT_OUT]: {
    label: 'Ajuste manual de salida',
    icon: 'mdi-minus-box',
    direction: -1, // Outflow
  },
  [StockMovementType.INVENTORY_COUNT_DECREASE]: {
    label: 'Disminución después de recuento de inventario',
    icon: 'mdi-database-minus',
    direction: -1, // Outflow
  },

  // Stock Reservations
  [StockMovementType.STOCK_RESERVED]: {
    label: 'Stock reservado',
    icon: 'mdi-lock',
    direction: -1,
  },
  [StockMovementType.STOCK_RELEASED]: {
    label: 'Stock liberado',
    icon: 'mdi-lock-open',
    direction: 1,
  },

  // Stock Corrections
  [StockMovementType.DAMAGE_WRITE_OFF]: {
    label: 'Baja por daño',
    icon: 'mdi-glass-fragile',
    direction: -1, // Outflow
  },
  [StockMovementType.THEFT_LOSS]: {
    label: 'Pérdida por robo',
    icon: 'mdi-account-off',
    direction: -1, // Outflow
  },

  // Others
  [StockMovementType.STOCK_ADJUSTMENT]: {
    label: 'Ajuste de stock',
    icon: 'mdi-tune',
    direction: 0, // Neutral
  },
  [StockMovementType.PRODUCTION_USAGE]: {
    label: 'Uso en producción',
    icon: 'mdi-factory',
    direction: -1, // Outflow
  },
  [StockMovementType.SAMPLE_DISTRIBUTION]: {
    label: 'Distribución de muestras',
    icon: 'mdi-gift',
    direction: -1, // Outflow
  },
  [StockMovementType.PROMOTIONAL_USE]: {
    label: 'Uso promocional',
    icon: 'mdi-bullhorn',
    direction: -1, // Outflow
  },
};
